import StarIcon from "@/assets/svg/StarIcon";
import "./styles.scss";
import { useLanguage } from "@/hook/useLanguage";

const FeaturedRibbon = ({ text }) => {
  const { isRTL } = useLanguage();
  return (
    <div className={`${isRTL ? "ribbon-rtl" : "ribbon"} `}>
      <span className="mx-2">
        <StarIcon />
      </span>
      <span className="font-manropeBold leading-none">{text}</span>
      <div className="ribbon-cut"></div>
    </div>
  );
};

export default FeaturedRibbon;
